/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const permissions = currentUser?.permissions || [];

  return {
    canAdmin: currentUser && currentUser.access === 'admin',
    // 菜单权限
    canSeeAnalysis: currentUser?.access === 'admin' || permissions.includes('menu:analysis'),
    canSeeProcessTemplate: currentUser?.access === 'admin' || permissions.includes('menu:process-template'),
    canSeeTask: currentUser?.access === 'admin' || permissions.includes('menu:task'),
    canSeeTaskBoard: currentUser?.access === 'admin' || permissions.includes('menu:task-board'),
    canSeeNodeExecution: currentUser?.access === 'admin' || permissions.includes('menu:node-execution'),
    // 按钮权限校验函数
    canDo: (actionKey: string) => {
      if (currentUser?.access === 'admin') return true;
      return permissions.includes(`btn:${actionKey}`);
    },
  };
}
